import type { PropsWithChildren, FC } from 'react';
import { useRef } from 'react';

import { Observed } from '@xing-com/crate-communication-in-view';

import { useInsightsTracking } from '../hooks/use-insights-tracking';

export type NwtTrackingOptionsProps = {
  itemUrn?: string;
  itemActorUrn?: string;
  moduleTitle?: string;
  position: number;
  verticalPosition: number;
  modulePosition?: number;
  positionInModule?: number;
};

type Props = {
  onEnter?: () => void;
  nwtTrackingOptions: NwtTrackingOptionsProps;
};

export const InViewTracking: FC<PropsWithChildren<Props>> = ({
  children,
  onEnter,
  nwtTrackingOptions,
}) => {
  const isTrackedRef = useRef(false);
  const { trackWithNWT } = useInsightsTracking();

  const handleOnEnter = (): void => {
    onEnter?.();

    if (isTrackedRef.current) {
      return;
    }

    trackWithNWT({
      event: 'entered_viewport',
      ...nwtTrackingOptions,
    });
    isTrackedRef.current = true;
  };

  return (
    <>
      {children}
      <Observed onEnter={handleOnEnter} onLeave={() => {}} />
    </>
  );
};
